<template>
  <a-modal
    class="modal-box"
    title="提示"
    :visible="visible"
    :centered="true"
    @cancel="cancel"
  >
    <div class="content">
      <p class="text-center padding-t-10 padding-b-30">
        该功能需在云译客客户端中使用，请前往下载
      </p>
    </div>

    <template #footer>
      <div class="footer-button text-center margin-b-20">
        <a-button size="large" @click="cancel" class="font-size-14 width-120">
          取消
        </a-button>
        <a-button
          type="primary"
          size="large"
          class="font-size-14 margin-l-20 width-120"
          @click="confirm"
        >
          前往下载
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
  export default {
    name: 'cancel',
    props: ['visible'],
    setup(props, ctx) {
      const cancel = () => {
        ctx.emit('update:visible', false)
      }
      const confirm = () => {
        cancel()
        window.open('/go/tsp_pc_login_option/home/client', '_blank')
      }

      return {
        cancel,
        confirm,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .modal-box {
    width: 620px;

    ::v-global(.ant-modal-footer) {
      border-top: 0;
    }
  }

  .content {
    font-size: 16px;
  }

  .width-120 {
    width: 120px;
  }
</style>
